import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/ContactPage.module.css';
import videoBackground from '../styles/background.mp4';

const ContactPage = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <div className={styles.contactPageContainer}>
       <video className={styles.contactPageVideoBackground} autoPlay loop muted>
              <source src={videoBackground} type="video/mp4" />
              Your browser does not support the video tag.
       </video>

 <header className={styles.contactPageHeaderMenu}>
        <div onClick={() => navigate('/')} className={styles.contactPagelogo}>
          Full Trucking Service
        </div>
        
        <div className={styles.hamburgerContact} onClick={() => setIsMenuOpen(!isMenuOpen)}>
          ☰
        </div>

        <nav className={`${styles.navMenuContact} ${isMenuOpen ? styles.activeContact : ''}`}>
          <ul>
            <li onClick={() => navigate('/about')}>About Us</li>
            <li onClick={() => navigate('/services')}>Services</li>
            <li onClick={() => navigate('/contact')}>Contact</li>
            <li onClick={() => navigate('/pricing')}>Register</li>
          </ul>
        </nav>
      </header>

      {/* 🔥 Fix: Adăugăm un spacer sub header pentru a evita suprapunerea */}
      <div className={styles.contactPageSpacer}></div>

      <div className={styles.contactPageContent}>
        <div className={styles.contactFormContainer}>
          <h1>Contact Us</h1>
          <p>Have questions? Need assistance? We’re here to help.</p>
          <form className={styles.contactPageForm}>
            <input type="text" placeholder="Company Name" className={styles.contactPageInput} required />
            <input type="text" placeholder="Your Name" className={styles.contactPageInput} required />
            <input type="tel" placeholder="Phone Number" className={styles.contactPageInput} required />
            <input type="email" placeholder="Your Email" className={styles.contactPageInput} required />
            <textarea placeholder="Your Message" className={styles.contactPageTextarea} required></textarea>
            <div className="flex items-start gap-2">
  <input
    type="checkbox"
    id="consent"
    required
    className="mt-1"
  />
  <label htmlFor="consent" className="text-sm text-gray-300">
    I agree to the{" "}
    <a
      href="https://2-bfs.com/privacy-policy"
      target="_blank"
      rel="noopener noreferrer"
      className="underline text-[#00b4ff] hover:text-[#0095cc]"
    >
      Privacy Policy
    </a>{" "}
    and understand that I will be contacted based on my submitted data.
  </label>
</div>

            <button type="submit" className={styles.contactPageButton}>Send Message</button>
          </form>
        </div>
      </div>

       <footer className={styles.contactPageFooter}>
  <a
    href="https://2-bfs.com/terms-and-conditions"
    target="_blank"
    rel="noopener noreferrer"
    className={styles.contactPagefooterLink}
  >
    Terms of Service
  </a>
  <a
    href="https://2-bfs.com/privacy-policy"
    target="_blank"
    rel="noopener noreferrer"
    className={styles.contactPagefooterLink}
  >
    Privacy Policy
  </a>
  <a
    href="https://2-bfs.com/panda-help"
    target="_blank"
    rel="noopener noreferrer"
    className={styles.contactPagefooterLink}
  >
    Help
  </a>
</footer>

    </div>
  );
};

export default ContactPage;
